// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3SJK-","right":"styles_right__2f0Ap"};